import { render, staticRenderFns } from "./GrocerTabLinks.vue?vue&type=template&id=47ef6bd0"
import script from "./GrocerTabLinks.vue?vue&type=script&lang=js"
export * from "./GrocerTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports